import {RestApiService} from '../../../rest-api.service';
import {ContactPersonCreateReq, ContactPersonDetailRes, ContactPersonUpdateReq} from '../../../../contracts/v0/crm';
import {ApiV0Crm} from '../api.v0.crm';
import {
    BaseCollectionModel,
    Pagination,
    SearchModel,
    YascEntityApiAdapterV3,
} from '@yasc/yasc-material-components';
import {map, Observable} from 'rxjs';

export class ApiV0CrmContactPerson
    implements YascEntityApiAdapterV3<ContactPersonDetailRes, ContactPersonDetailRes, ContactPersonCreateReq, ContactPersonUpdateReq, number> {

    segment = '/contact';
    readonly idKey = 'id' as const;
    readonly modelTypes = {
        row: ContactPersonDetailRes,
        detail: ContactPersonDetailRes,
        create: ContactPersonCreateReq,
        patch: ContactPersonUpdateReq,
    };

    constructor(v0: ApiV0Crm, private rest: RestApiService) {
        this.segment = v0.segment + this.segment;
    }

    search(searchModel: SearchModel = new SearchModel({})) {
        return this.rest.post<SearchModel, BaseCollectionModel<ContactPersonDetailRes>>(`${this.segment}/search`, ContactPersonDetailRes, searchModel)
    }

    detail(id: number): Observable<ContactPersonDetailRes> {
        return this.search(new SearchModel({pagination: new Pagination({index: 0, size: 1})}).lookForId(id)).pipe(
            map(result => {
                const contact = result.data[0];
                if (!contact) throw new Error(`Contact ${id} not found`);
                return contact;
            })
        );
    }

    company(id: number) {
        return this.rest.get<BaseCollectionModel<ContactPersonDetailRes>>(`${this.segment}/company/${id}`, ContactPersonDetailRes)
    }

    create(createReq: ContactPersonCreateReq): Observable<ContactPersonDetailRes> {
        return this.createContact(createReq);
    }

    createContact(createReq: ContactPersonCreateReq) {
        return this.rest.post<ContactPersonCreateReq, ContactPersonDetailRes>(`${this.segment}/create`, ContactPersonDetailRes, createReq)
    }

    bulkCreate(createReq: ContactPersonCreateReq[]) {
        return this.rest.post<ContactPersonCreateReq[], BaseCollectionModel<ContactPersonDetailRes>>(`${this.segment}/bulk`, ContactPersonDetailRes, createReq)
    }

    patch(id: number, updateReq: ContactPersonUpdateReq): Observable<ContactPersonDetailRes> {
        updateReq.id = id;
        return this.patchContact(updateReq);
    }

    patchContact(updateReq: ContactPersonUpdateReq) {
        return this.rest.patch<ContactPersonUpdateReq, ContactPersonDetailRes>(this.segment, ContactPersonDetailRes, updateReq)
    }

    delete(ids: number[]): Observable<void> {
        return this.bulkDelete(ids);
    }

    bulkDelete(ids: number[]) {
        return this.rest.delete<void>(this.segment, {}, ids)
    }
}
